module.exports = __webpack_public_path__ + "img/nature-34.3b767abe.jpg";